import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getInvitation, registerUser } from "../store/actions";
import Loading from "../components/shared/loader";
import { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { ReactComponent as ProfileIcon } from "assets/svgs/profile.svg";
import { ReactComponent as ArrowLeftIcon } from "assets/svgs/arrow-left.svg";
import { ReactComponent as EmailIcon } from "assets/svgs/email-2.svg";
import { ReactComponent as PhoneIcon } from "assets/svgs/phone.svg";
import { ReactComponent as PinIcon } from "assets/svgs/pin.svg";
import { ReactComponent as PassIcon } from "assets/svgs/password.svg";
import { ReactComponent as TogglePassIcon } from "assets/svgs/view-toggle.svg";
import "styles/login.css";
//build me a registerUser file based on this file
function Regsiter({ logo }) {
  const dispatch = useDispatch();
  const { loading, error, user } = useSelector((state) => state.authentication);
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const [showPassword, setShowPassword] = useState(false);
  const [searchParams] = useSearchParams();
  const { register, handleSubmit, reset } = useForm();

  const searchParamsObj = Object.fromEntries([...searchParams]);

  useEffect(() => {
    if (user?.email)
      reset({
        ...user,
        firstName: user?.firstName,
        lastName: user?.lastName,
        email: user?.email,
      });
    if (searchParamsObj?.code?.length > 0 && !user?.email)
      dispatch(getInvitation(searchParamsObj?.code));
  }, [reset, searchParams, user]);

  useEffect(() => {
    if (error) {
      toast(error, { toastId: error });
    }
  }, [error]);

  const handleShowPassword = (e) => {
    e.preventDefault();

    setShowPassword((prevShowPassword) => {
      return !prevShowPassword;
    });
  };

  const onSubmit = (data) => {
    dispatch(
      registerUser({
        data,
        navigate,
        searchParams: searchParamsObj?.code
          ? `code=${searchParamsObj?.code}`
          : "",
      })
    );
  };

  if (loading) return <Loading />;

  return (
    <>
      <section className="register_page__">
        <div className="register_page_from_section__">
          <Link className="go_back_home__" to={"/"}>
            <figure className="shape__">
              <ArrowLeftIcon />
            </figure>
            <FormattedMessage id="backHome" />
          </Link>
          <h2 className="register_head__">
            <FormattedMessage id="register" />
          </h2>

          <form
            className="register_form_content__"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row mx-0">
              <div className="login_input_group__ px-0 col-12 col-md-6 ps-md-2 px-0">
                <figure className="shape__">
                  <ProfileIcon width="24" height="20" />
                </figure>

                <input
                  {...register("firstName")}
                  className="input__"
                  placeholder={formatMessage({ id: "firstName" })}
                />
              </div>
              <div className="login_input_group__ px-0 col-12 col-md-6 pe-md-2 px-0">
                <figure className="shape__">
                  <ProfileIcon width="24" height="20" />
                </figure>

                <input
                  {...register("lastName")}
                  className="input__"
                  placeholder={formatMessage({ id: "lastName" })}
                />
              </div>
            </div>

            <div className="login_input_group__">
              <figure className="shape__">
                <EmailIcon width="24" height="20" />
              </figure>

              <input
                type="email"
                {...register("email")}
                className="input__"
                placeholder={formatMessage({ id: "email" })}
                {...(user?.email ? { readOnly: true } : {})}
              />
            </div>

            <div className="login_input_group__">
              <figure className="shape__">
                <PhoneIcon width="24" height="20" />
              </figure>

              <input
                type="number"
                {...register("phone")}
                className="input__"
                placeholder={formatMessage({ id: "phone" })}
              />
            </div>

            <div className="login_input_group__">
              <figure className="shape__">
                <PinIcon width="24" height="20" />
              </figure>

              <input
                {...register("address")}
                className="input__"
                placeholder={formatMessage({ id: "address" })}
              />
            </div>

            <div className="login_input_group__">
              <figure className="shape__">
                <PassIcon width="24" height="20" />
              </figure>

              <input
                type={showPassword ? "text" : "password"}
                {...register("password")}
                className="input__"
                placeholder={formatMessage({ id: "password" })}
              />

              <button
                onClick={handleShowPassword}
                className={`toggle_show_password_ ${
                  showPassword ? "active__" : ""
                }`}
              >
                <TogglePassIcon />
              </button>
            </div>

            <div className="register_submit_button_wrapper__">
              <input
                type="submit"
                className="submit__  "
                value={formatMessage({ id: "register" })}
              />
            </div>
            {
              // <FormLoader />
            }
          </form>
        </div>

        <div className="register_page_logo_section__">
          <div className="register_logo__">
            <Link to={"/"}>
              <img src={logo} alt="" />
            </Link>
          </div>

          <div className="register_info_content__">
            <h2 className="head__">
              <FormattedMessage id="welcome" />
            </h2>
            <p className="parg__">
              <FormattedMessage id="ToStayInTouchWithUsYourPersonalInformation" />
            </p>
            <Link className="create_store__" to="/login">
              <FormattedMessage id="login" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Regsiter;
